import React, { Component } from 'react';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import styles from './style.module.css';
import { percent, numberWithCommas } from '../../../../helpers';
import StepSixForm from '../../components/forms/step-six';
import InfoBox from '../../../../common/components/info-box';
import FixedHeading from '../../../../common/components/fixed-heading';
import { formDetails as StepOneFormDetails } from '../../components/forms/step-one';
import { formDetails as StepSixFormDetails } from '../../components/forms/step-six';

const tooltip = {
    title: 'Did you know?',
    content: 'Sometimes employers allow you the ability to automatically deduct money from your paycheque to make contributions to an employee RRSP or Pension Plan. You can include these dollar amounts in the section above labelled "OTHER".'
};

class StepSix extends Component {
    render() {
        const {
            props: {
                income,
                expense
            }
        } = this;

        const recommendation = {
            title: 'Recommendation',
            content: <span>We recommend saving <strong>{StepSixFormDetails.range.high}%</strong> or more of your net income.</span>
        };

        let message = <span>Your net income is <strong>${numberWithCommas(income)}</strong>.</span>;

        if (percent(expense, income) > 0) {
            message = <span><span className={styles.hideMobile}>Currently </span><strong>{percent(expense, income)}%</strong> of your <strong>${numberWithCommas(income)}</strong> net income.</span>;
        }

        return (
            <div className={styles.page}>
                <p className={styles.topTitle}>Monthly Expenses</p>
                <h1 className={styles.mainTitle}>{StepSixFormDetails.title}</h1>
                <InfoBox
                    title={recommendation.title}
                    content={recommendation.content}
                />
                <FixedHeading
                    title={StepSixFormDetails.title}
                    content={message}
                />
                <StepSixForm/>
                <InfoBox
                    title={tooltip.title}
                    content={tooltip.content}
                />
            </div>
        );
    }
}

const selector = formValueSelector(StepSixFormDetails.formName);
const StepOneForm = formValueSelector(StepOneFormDetails.formName);

export default connect(state => {
    const expense = selector(state, StepSixFormDetails.totalKey);
    const income = StepOneForm(state, StepOneFormDetails.totalKey);

    return {
        income: income ? income : 0,
        expense: expense ? expense : 0
    }
})(StepSix);
